export const translations = {
  ro: {
    nav: {
      about: "Despre Noi",
      amenities: "Facilități",
      gallery: "Galerie",
      contact: "Contact",
    },
    hero: {
      overline: "Boutique Residence • Arad",
      title: "White Residence Arad",
      subtitle: "Rafinament și confort absolut în inima Aradului.",
      cta: "Rezervă Acum",
    },
    about: {
      label: "Povestea Noastră",
      headline: "Descoperă o oază de liniște și eleganță.",
      text: "La White Residence, fiecare detaliu este gândit pentru a-ți oferi o experiență de neuitat. Fie că ești în trecere sau cauți o ședere prelungită în Arad, designul nostru atent selecționat și ospitalitatea caldă te vor face să te simți acasă.",
      stats: [
        { value: "6", label: "Camere boutique" },
        { value: "24/7", label: "Recepție disponibilă" },
        { value: "100%", label: "Confort garantat" },
      ],
    },
    amenities: {
      label: "Facilități Premium",
      headline: "Confort fără compromisuri.",
      items: [
        { title: "Climatizare", desc: "Temperatură perfectă, indiferent de sezon." },
        { title: "Wi-Fi Gratuit", desc: "Conexiune rapidă pentru business și relaxare." },
        { title: "Smart TV", desc: "Divertisment la standarde înalte." },
        { title: "Băi Moderne", desc: "Finisaje premium pentru confortul tău absolut." },
      ],
    },
    gallery: {
      label: "Interioare",
      headline: "Design gândit pentru tine.",
      sub: "O selecție atentă de spații care îmbină eleganța clasică cu liniile contemporane.",
    },
    location: {
      label: "Locație & Contact",
      headline: "Te așteptăm cu drag.",
      addressLabel: "Adresă",
      address: "Str. Voluntarilor, nr.1, Arad",
      phoneLabel: "Telefon",
      phone: "+40 755 079 874",
      cta: "Sună pentru Rezervare",
      mapTitle: "Hartă",
    },
    footer: {
      tagline: "Boutique residence în inima Aradului.",
      rights: "Toate drepturile rezervate.",
    },
  },
  en: {
    nav: {
      about: "About Us",
      amenities: "Amenities",
      gallery: "Gallery",
      contact: "Contact",
    },
    hero: {
      overline: "Boutique Residence • Arad",
      title: "White Residence Arad",
      subtitle: "Absolute refinement and comfort in the heart of Arad.",
      cta: "Call to Reserve",
    },
    about: {
      label: "Our Story",
      headline: "Discover an oasis of tranquility and elegance.",
      text: "At White Residence, every detail is meticulously designed to offer you an unforgettable experience. Whether you are passing through or seeking an extended stay in Arad, our curated design and warm hospitality will make you feel right at home.",
      stats: [
        { value: "6", label: "Boutique rooms" },
        { value: "24/7", label: "Front desk" },
        { value: "100%", label: "Comfort assured" },
      ],
    },
    amenities: {
      label: "Premium Amenities",
      headline: "Uncompromising comfort.",
      items: [
        { title: "Air Conditioning", desc: "Perfect temperature, regardless of the season." },
        { title: "Free Wi-Fi", desc: "High-speed connection for business and leisure." },
        { title: "Smart TV", desc: "High-standard entertainment." },
        { title: "Modern Bathrooms", desc: "Premium finishes for your absolute comfort." },
      ],
    },
    gallery: {
      label: "Interiors",
      headline: "Design tailored for you.",
      sub: "A carefully curated selection of spaces blending classic elegance with contemporary lines.",
    },
    location: {
      label: "Location & Contact",
      headline: "We warmly welcome you.",
      addressLabel: "Address",
      address: "Voluntarilor St., No.1, Arad",
      phoneLabel: "Phone",
      phone: "+40 755 079 874",
      cta: "Call for Reservation",
      mapTitle: "Map",
    },
    footer: {
      tagline: "Boutique residence in the heart of Arad.",
      rights: "All rights reserved.",
    },
  },
};

export const media = {
  hero: "https://customer-assets.emergentagent.com/job_4a992dba-ab2c-4f97-bca9-079559d0b37d/artifacts/jlppl2ok_WhatsApp%20Image%202026-03-04%20at%2014.21.12%20%2811%29.jpeg",
  gallery: [
    {
      url: "https://customer-assets.emergentagent.com/job_4a992dba-ab2c-4f97-bca9-079559d0b37d/artifacts/hjc4e4jh_WhatsApp%20Image%202026-03-04%20at%2014.21.12%20%2822%29.jpeg",
      alt: "Suite with emerald lounge chair",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_4a992dba-ab2c-4f97-bca9-079559d0b37d/artifacts/h5humtyo_WhatsApp%20Image%202026-03-04%20at%2014.21.12%20%282%29.jpeg",
      alt: "Modern bathroom with chevron tiles",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_4a992dba-ab2c-4f97-bca9-079559d0b37d/artifacts/jlppl2ok_WhatsApp%20Image%202026-03-04%20at%2014.21.12%20%2811%29.jpeg",
      alt: "Spacious bedroom with crisp linens",
    },
    {
      url: "https://static.prod-images.emergentagent.com/jobs/4a992dba-ab2c-4f97-bca9-079559d0b37d/images/71e8d242250ca55aea780baccd35f2aea1c7557fea080a17cdb621d93d2b8ded.png",
      alt: "Boutique amenities detail",
    },
  ],
  about_texture:
    "https://static.prod-images.emergentagent.com/jobs/4a992dba-ab2c-4f97-bca9-079559d0b37d/images/540d1954a0b57c2a2fd495356ba57197d49ef33bf34d515b07f64d3d20f91cda.png",
  mapSrc:
    "https://maps.google.com/maps?q=Strada%20Voluntarilor%201%2C%20Arad&t=&z=15&ie=UTF8&iwloc=&output=embed",
};

export const PHONE = "+40 755 079 874";
export const PHONE_TEL = "+40755079874";
